/* eslint-disable @nx/enforce-module-boundaries */
import {
  Card,
  Container,
  HStack,
  Heading,
  Scrollable,
  Stack,
  Text,
  Box,
  VStack,
  Button,
} from '@mybridge/ui';
import React, { useEffect } from 'react';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllEvent,
  getAllMeetings,
  getEventsFromGoogle,
  getEventsFromOutlook,
} from 'v4/store/actions/calendar.actions';
import { getConnectionsData } from 'v4/store/actions/connection.actions';
import styles from '../../components/header/status-dropdown/statusProfile.module.scss';
// import styles from '../../components/header/status-dropdown/statusProfile.module.scss';
import dynamic from 'next/dynamic';
const CalendarComponent = dynamic(() => import('./calendar-component'), {
  ssr: false,
});
const UpcomingMeetings = dynamic(() => import('./upcoming-meetings'), {
  ssr: false,
})
import { useRouter } from 'next/router';
import CalendarSidebar from './calendar-sidebar';
// import UpcomingMeetings from './upcoming-meetings';
import { isMobile } from 'react-device-detect';
import { DashboardMyCircle } from '../dashboard/circle';
import moment from 'moment';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <Heading>Something went wrong.</Heading>
          <Text>{JSON.stringify(this.state.errorInfo, null, 2)}</Text>
        </>
      );
    }

    return this.props.children;
  }
}

const CalendarPage = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  useEffect(() => {
    const startDateStr = moment().locale('en').format('YYYY-MM-DD') + 'T00:00:00';
    const endDateStr = moment().locale('en').add(60, 'days').format('YYYY-MM-DD') + 'T23:59:00';
    dispatch(getAllMeetings({
      startDate: startDateStr,
      endDate: endDateStr
    }));
    dispatch(getAllEvent());
    if (userProfileInfo?.google_calendar_email) dispatch(getEventsFromGoogle());
    if (userProfileInfo?.outlook_calendar_email)
      dispatch(getEventsFromOutlook());
    // dispatch(getConnectionsData());
  }, [userProfileInfo]);

  return (
    <>
      {isMobile ? (
        <Container w="100%" maxW="1000px" p={0} pt={3} bg="white" minHeight="auto">
          <Box>
            <CalendarSidebar isDashboard={false} />
          </Box>
          <Card p={[0, 2, 4]} pt={[3, 4, 4]} mb={3} mt={[4, null]} bg="white" boxShadow="none">
            <ErrorBoundary>
              <CalendarComponent />
            </ErrorBoundary>
          </Card>
          <ErrorBoundary>
            <UpcomingMeetings />
          </ErrorBoundary>
          <Box display="flex" justifyContent="center" mt={2} mb={4}>
            <Button
              variant="link"
              color="brandPrimary.500"
              onClick={() => router.push('/profile/calendar/calendar-listing')}
            >
              Show All
            </Button>
          </Box>
        </Container>
      ) : (
        <HStack minH={['auto', 'auto', '120vh']} alignItems="stretch" spacing={0}  >
          <Stack
            display={['none', 'none', 'flex']}
            // className={styles.left}
            // w={['90px', '90px', '280px']}
            pos="sticky"
            top="64px"
            spacing={2}
            // bg="white"
            // boxShadow="2px 0px 6px 0px #00000033"
            minH={isMobile?"100vh":"90vh"}
            borderBottom="1px solid #e0e0e094"
            height={'500px'}
            zIndex="999"

            // overflowX={"hidden"}
            // overflowy={"auto"}
          >
            {/* <Scrollable maxH="99vh" flex={1}> */}

            <VStack
              spacing={2}
              justifyContent="space-between"
              height="100%"
              align="stretch"
              h="calc(100vh - 0px)"
              backgroundColor="rgb(255, 255, 255)"
            >
              <VStack spacing={2} align="stretch" h="100%" flex="1">
                <SiteShortcutLinks />

                <Box className={styles.hideTitle}>
                  <DashboardMyCircle w="230px" h="300px" flex="1" />
                </Box>
              </VStack>
            </VStack>
          </Stack>

          <Box {...(!isMobile && { top: "64px", pos: "sticky", maxH: "90vh" })} p={isMobile ? '0%' : '1%'}>
            <CalendarSidebar isDashboard={false} />
          </Box>
          <Stack w={['100%', '65%', '100%']} justifyContent="start" my={8}>
            <Container maxW="1000px" pt={3}>
              <Card
                p={[0, 2, 4]}
                pt={[3, 4, 4]}
                mb={3}
                bg="white"
                boxShadow="none"
              >
                <ErrorBoundary>
                  <CalendarComponent />
                </ErrorBoundary>
              </Card>
              <ErrorBoundary>
                <UpcomingMeetings />
              </ErrorBoundary>
            </Container>
          </Stack>
        </HStack>
      )}
    </>
  );
};

export default CalendarPage;
